import ITranslation from "../../interface/translation";
import Message from "../../enum/message";

export default {
    id: 'pt',
    name: 'Português',
    msg: {
        [Message.mins]: 'mins',
        [Message.checktrue]: 'Sim',
        [Message.checkfalse]: 'Não',
        [Message.checkindetermine]: 'Desconhecido',
        [Message.fieldfrom]: 'Começa em',
        [Message.fieldto]: 'Termina em',
        [Message.fieldduration]: 'Duração',
        [Message.dateonly]: 'Data',
        [Message.timeonly]: 'Hora',
        [Message.record]: 'Registro',
        [Message.owner]: 'Proprietário',
        [Message.defaulttablename]: 'Nova tabela',
        [Message.defaultfieldname]: 'Novo campo',
        [Message.emptyevent]: '',
        [Message.globalview]: 'Todos',
        [Message.overdue]: 'Vencidos',
        [Message.notavailable]: 'N/D',
        [Message.supportname]: 'Suporte FrameLink',
        [Message.total]: 'Total',
        [Message.backup]: 'Backup',
        [Message.emptysheet]: 'Sem nome',
        [Message.verifyemailtitle]: 'Verificação de Endereço',
        [Message.verifyemailtext]: 'Obrigado por utilizar o FrameLink!\nClique no botão «Verificar» para poder enviar emails a partir do FrameLink.\nSe desconhece a origem desta mensagem, ignore-a simplesmente.',
        [Message.verifyemailsubmit]: 'Verificar',
        [Message.verifyphonetext]: 'Obrigado por utilizar o FrameLink! Clique neste link [VERIFICATION_LINK] para verificar seu número de telefone',
        [Message.gdprallow]: 'Permitir',
        [Message.gdprdecline]: 'Declínio',
        [Message.copy]: 'Cópia de',
        [Message.publicformnotification]: 'Notificação de formulário público'
    }
} as ITranslation;